import React from 'react';

import { EButtonSize } from '@domain/enums/components/EButton';

import { useBequestDigital } from '@helpers/hooks/pages/consent/useBequestDigital';

import TermsReader from './TermsReader';

import * as S from './styles';

const Body: React.FC = () => {
  const { isCheckboxSelected, onCheckboxChange, onSubmit, isSubmittingTerms } = useBequestDigital();

  return (
    <S.Wrapper>
      <S.CheckboxAndTermsReaderWrapper>
        <TermsReader />

        <S.LabelAndCheckboxWrapper>
          <S.Checkbox
            defaultChecked={isCheckboxSelected}
            onChange={onCheckboxChange}
            id="bequest-checkbox"
          />

          <S.Label htmlFor="bequest-checkbox">
            Aceito conceder acesso aos dados de minha loja à Bequest
          </S.Label>
        </S.LabelAndCheckboxWrapper>
      </S.CheckboxAndTermsReaderWrapper>

      <S.SubmitButton
        onClick={onSubmit}
        isLoading={isSubmittingTerms}
        buttonSize={EButtonSize.MEDIUM}
      >
        Prosseguir para a plataforma
      </S.SubmitButton>
    </S.Wrapper>
  );
};

export default Body;
